var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal show fade",attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[(_vm.display === true)?_c('div',{staticClass:"modal-content"},[_c('header',{staticClass:"modal-header",class:{
                'bg-primary':!_vm.confirmed,
                'bg-success':_vm.confirmed
                }},[_c('h3',[_vm._t("header")],2)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),_c('footer',{staticClass:"modal-footer py-0"},[_vm._t("footer")],2)]):_vm._e()])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781a74bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/base/BaseModal.vue
// module id = u6EJ
// module chunks = 0